export default __webpack_public_path__ + "static/media/icon-comment-grey.71923021.svg";